<template>
  <section :class="[ns.b(), ns.is('vertical', isVertical)]">
    <slot></slot>
  </section>
</template>
<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useNamespace } from '@tw-element/hooks'

import type { Component, VNode } from 'vue'

export default defineComponent({
  name: 'TwContainer',
  props: {
    direction: {
      type: String,
      default: '',
    },
  },
  setup(props, { slots }) {
    const ns = useNamespace('container')

    const isVertical = computed(() => {
      if (props.direction === 'vertical') {
        return true
      } else if (props.direction === 'horizontal') {
        return false
      }
      if (slots && slots.default) {
        const vNodes: VNode[] = slots.default()
        return vNodes.some((vNode) => {
          const tag = (vNode.type as Component).name
          return tag === 'TwHeader' || tag === 'TwFooter'
        })
      } else {
        return false
      }
    })
    return {
      isVertical,
      ns,
    }
  },
})
</script>
